import Vue from 'vue'
import Router from 'vue-router'

const Login = () => import('../views/login/index.vue')
const NewPassword = () => import('../views/login/new_pswd.vue')
const notFound = () => import('../views/notFound.vue')
const layout = () => import('../views/layout/index.vue')

// 面板
const dashboard = () => import('../views/dashboard/index.vue')

// 用户
const userIndex = () => import('../views/users/index.vue')

// 角色
const roleIndex = () => import('../views/roles/index.vue')

// 成品
const ProductTemplateList = () => import('../views/product_templates/drill.vue')
const ProductTemplateShow = () => import('../views/product_templates/show.vue')
const ProductList = () => import('@/views/products/drill.vue')
const ProductShow = () => import('../views/products/show.vue')

// 组装流程外添加成品使用记录
const ProductRecordList = () => import("../views/product_records/drill.vue")
const InstrumentRecordList = () => import("../views/product_records/instrument.vue")

// 配件
const itemTemplateList = () => import('../views/item_templates/drill.vue')
const itemTemplateShow = () => import('../views/item_templates/show.vue')
const itemList = () => import('../views/items/drill.vue')
const itemShow = () => import('../views/items/show.vue')

// 成品
const InstrumentTemplateList = () => import('../views/product_templates/instrument.vue')
const InstrumentList = () => import('@/views/products/instrument.vue')
const GroupInstrumentList = () => import('@/views/products/group_instrument.vue')

const InstrumentInventoryList = () => import('../views/product_inventories/instrument.vue')

// 配件
const InstrumentItemTemplateList = () => import('../views/item_templates/instrument.vue')
const instrumentItemList = () => import('../views/items/instrument.vue')

//配件库存分布
const InstrumentItemInventoryList = () => import('../views/item_inventories/instrument.vue')

// 基地设置
const baseList = () => import('../views/bases/index.vue')

// 消息列表
const messageList = () => import('../views/messages/index.vue')

//钻井管理
const drillWellList = () => import('../views/drill_wells/index.vue')
const drillWellShow = () => import('../views/drill_wells/show.vue')

// 物资申请
const applyList = () => import('../views/applies/all_apply.vue')
const myApplyList = () => import('../views/applies/my_apply.vue')
const approveApplyList = () => import('../views/applies/approve_apply.vue')
const applyDetail = () => import('../views/applies/detail.vue')

//物资调拨

const supplyList = () => import('../views/supplies/all_supply.vue')
const mySupply = () => import('../views/supplies/my_supply.vue')
const supplyDetail = () => import('../views/supplies/detail.vue')

// 成品统计
const productStatistics = () => import('../views/product_statistics/drill.vue')
const instrumentStatistics = () => import('../views/product_statistics/instrument.vue')

// 配件统计
const itemStatistics = () => import('../views/item_statistics/item.vue')
const instrumentItemStatistics = () => import('../views/item_statistics/instrument_item.vue')


Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
	return originalPush.call(this, location).catch(err => err)
}

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
	return originalReplace.call(this, location).catch(err => err);
};

export const constantRoutes = [
	{
		path: '/',
		name: 'index',
		redirect: '/dashboard'
	},
	{
		path: '/login',
		name: '登陆',
		component: Login
	},
	{
		path: '/setpswd',
		name: '重设密码',
		component: NewPassword
	},
	{
		path: '/dashboard',
		component: layout,
		children: [
			{
				path: 'home',
				name: 'home',
				component: dashboard,
				meta: { name: '工作台' }
			},
			{
				path: '/users',
				component: userIndex,
				moduleName: "users",
				meta: { name: '用户列表', module: "user", authName: 'userList' }
			},
			{
				path: '/roles',
				component: roleIndex,
				meta: { name: '角色列表', module: "role", authName: 'roleList' }
			},
			{
				path: '/product_templates',
				component: ProductTemplateList,
				meta: { name: '成品分类', module: "product_template", authName: 'productTemplateList' }
			},
			{
				path: '/product_templates/:id',
				component: ProductTemplateShow,
				meta: { name: '成品分类详情', module: "product_template", authName: 'productTemplateDetail' }
			},
			{
				path: '/product_records',
				component: ProductRecordList,
				meta: { name: '使用记录列表', module: "product_record", authName: 'productDisassemble' }
			},
			{
				path: '/instrument_records',
				component: InstrumentRecordList,
				meta: { name: '使用记录列表', module: "instrument_record", authName: 'instrumentDisassemble' }
			},
			{
				path: '/products',
				component: ProductList,
				meta: { name: '成品列表', module: "product", authName: 'productList' }
			},
			{
				path: '/products/:id',
				component: ProductShow,
				meta: { name: '成品详情', module: "product", authName: 'productDetail' }
			},
			{
				path: '/item_templates',
				component: itemTemplateList,
				meta: { name: '配件分类', module: "item_template", authName: 'itemTemplateList' }
			},
			{
				path: '/item_templates/:id',
				component: itemTemplateShow,
				meta: { name: '配件分类详情', module: "item_template", authName: 'itemTemplateDetail' }
			},
			{
				path: '/items',
				component: itemList,
				meta: { name: '配件列表', module: "item", authName: 'itemList' }
			},
			{
				path: '/items/:id',
				component: itemShow,
				meta: { name: '配件详情', module: "item", authName: 'itemDetail' }
			},
			{
				path: '/instrument_templates',
				component: InstrumentTemplateList,
				meta: { name: '成品分类', module: "instrument_template", authName: 'instrumentTemplateList' }
			},
			{
				path: '/instrument_templates/:id',
				component: ProductTemplateShow,
				meta: { name: '成品分类详情', module: "instrument_template", authName: 'instrumentTemplateDetail' }
			},
			{
				path: '/instruments',
				component: InstrumentList,
				meta: { name: '成品列表', module: "instrument", authName: 'instrumentList' }
			},
			{
				path: '/group_instruments',
				component: GroupInstrumentList,
				meta: { name: '无编码成品', module: "group_instrument", authName: 'instrumentList' }
			},
			{
				path: '/instrument_inventories',
				component: InstrumentInventoryList,
				meta: { name: '库存分布', module: "instrument_inventory", authName: 'instrumentInventoryList' }
			},
			{
				path: '/instruments/:id',
				component: ProductShow,
				meta: { name: '成品详情', module: "instrument", authName: 'instrumentDetail' }
			},
			{
				path: '/instrument_item_templates',
				component: InstrumentItemTemplateList,
				meta: { name: '配件分类', module: "instrument_item_template", authName: 'instrumentItemTemplateList' }
			},
			{
				path: '/instrument_item_templates/:id',
				component: itemTemplateShow,
				meta: { name: '配件分类详情', module: "instrument_item_template", authName: 'instrumentItemTemplateListDetail' }
			},
			{
				path: '/instrument_items',
				component: instrumentItemList,
				meta: { name: '配件', module: "instrument_item", authName: 'instrumentItemList' }
			},
			{
				path: '/instrument_items/:id',
				component: itemShow,
				meta: { name: '配件详情', module: "instrument_item", authName: 'instrumentItemDetail' }
			},
			{
				path: '/instrument_item_inventories',
				component: InstrumentItemInventoryList,
				meta: { name: '库存分布', module: "instrument_item_inventory", authName: 'instrumentItemInventoryList' }
			},
			{
				path: '/bases',
				component: baseList,
				meta: { name: '基地列表', module: "base", authName: 'baseList' }
			},
			{
				path: '/messages',
				component: messageList,
				meta: { name: '消息列表', module: "message" }
			},
			{
				path: '/drill_wells',
				component: drillWellList,
				meta: { name: '钻井列表', module: "drill_well", authName: 'drillWellList' }
			},
			{
				path: '/drill_wells/:id',
				component: drillWellShow,
				meta: { name: '钻井详情', module: "drill_well", authName: 'drillWellDetail' }
			},
			{
				path: '/supplies',
				component: supplyList,
				meta: { name: '调拨列表', module: "supply", authName: 'supplyList' }
			},
			{
				path: '/my_supplies',
				component: mySupply,
				meta: { name: '接收列表', module: "my_supply", authName: 'supplyReceiveList' }
			},
			{
				path: '/supplies/:id',
				component: supplyDetail,
				meta: { name: '调拨详情', module: "supply", authName: 'supplyDetail' }
			},
			{
				path: '/my_supplies/:id',
				component: supplyDetail,
				meta: { name: '调拨详情', module: "my_supply", authName: 'supplyReceiveDetail' }
			},
			{
				path: '/applies',
				component: applyList,
				meta: { name: '所有申请', module: "apply", authName: 'applyList' }
			},
			{
				path: '/my_applies',
				component: myApplyList,
				meta: { name: '我的申请', module: "my_apply", authName: 'myApplyList' }
			},
			{
				path: '/approve_applies',
				component: approveApplyList,
				meta: { name: '待审批', module: "approve_apply", authName: 'approveApplyList' }
			},
			{
				path: '/applies/:id',
				component: applyDetail,
				meta: { name: '申请详情', module: "apply", authName: 'applyList' }
			},
			{
				path: '/my_applies/:id',
				component: applyDetail,
				meta: { name: '申请详情', module: "my_apply", authName: 'myApplyList' }
			},
			{
				path: '/approve_applies/:id',
				component: applyDetail,
				meta: { name: '申请详情', module: "approve_apply", authName: 'approveApplyList' }
			},
			{
				path: '/product_statistics',
				component: productStatistics,
				meta: { name: '数据统计', module: "product_statistics", authName: 'productStatistics' }
			},
			{
				path: '/instrument_statistics',
				component: instrumentStatistics,
				meta: { name: '数据统计', module: "instrument_statistics", authName: 'instrumentStatistics' }
			},
			{
				path: '/item_statistics',
				component: itemStatistics,
				meta: { name: '数据统计', module: "item_statistics", authName: 'itemStatistics' }
			},
			{
				path: '/instrument_item_statistics',
				component: instrumentItemStatistics,
				meta: { name: '数据统计', module: "instrument_item_statistics", authName: 'instrumentItemStatistics' }
			},
		]
	},
	{
		path: '*',
		component: notFound,
		meta: { title: '404' }
	}
]

const createRouter = () => new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: constantRoutes,
	scrollBehavior(to, from, savedPosition) {
		return new Promise((resolve, reject) => {
			setTimeout(() => {
				if (savedPosition) {
					resolve(savedPosition)
					return
				}
				resolve({ x: 0, y: 0 })
			}, 500)
		})
	}
})

const router = createRouter()

export default router
